export default "__VITE_ASSET__ZqI$g992__"